import { MaterialModule } from '../../../../material.module';
import { MatDialogRef } from '@angular/material/dialog';
import { ReactiveFormsModule } from '@angular/forms';
import { Component, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { Subject } from 'rxjs';

@Component({
    selector: 'shared-create-org-position-dialog',
    template: `
        <h2 mat-dialog-title class="m-0">
            Help - Organization Hierarchy

            <!-- Close button. -->
            <button mat-icon-button mat-dialog-close class="close-button">
                <mat-icon>close</mat-icon>
            </button>
        </h2>

        <mat-dialog-content class="h-100-70 w-100">
            <div class="view-container m-3 w-100">
                <div class="view-header">
                    <span class="viewer-title-spacer">Create new Position</span>
                </div>

                <div class="view-content">
                    <!-- Legend showing the different colours and borders and what they mean. Dashed lime green, solid green, grey dashed, solid dashed. -->
                    <!-- Solid grey means there is inheritance flowing upward. -->
                    <!-- Dashed grey means there isn't inheritance flowing upward. -->
                    <!-- Solid green is the inheritance of the selected position. -->
                    <!-- Dashed lime green is the inheritance of the hovered position. -->
                    <div class="legend">
                        <div class="legend-item">
                            <div class="legend-item-color dashed-lime-green-box"></div>
                            <span class="legend-item-text dashed-lime-green">Hovered Position inheritance line</span>
                        </div>
                        <div class="legend-item">
                            <div class="legend-item-color solid-green-box"></div>
                            <span class="legend-item-text solid-green">Selected Position's inheritance line</span>
                        </div>
                        <div class="legend-item">
                            <div class="legend-item-color dashed-grey-box"></div>
                            <span class="legend-item-text dashed-grey">No Inherited Security</span>
                        </div>
                        <div class="legend-item">
                            <div class="legend-item-color solid-grey-box"></div>
                            <span class="legend-item-text solid-grey">Inherited Security</span>
                        </div>
                    </div>

                    <p>TODO: list more helpful information about inheritance and access.</p>
                    <p>TODO: explain why some security is not inherited.</p>
                    <p>TODO: explain why inheritance is based on positions and not users.</p>
                    <img
                        style="width: 35rem;"
                        src="assets/images/help/org-hierarchy-example.png"
                        alt="Org Hierarchy"
                        class="org-hierarchy-image"
                    />
                </div>
            </div>
        </mat-dialog-content>

        <mat-dialog-actions align="end">
            <button mat-button mat-dialog-close>Close</button>
        </mat-dialog-actions>
    `,
    imports: [MaterialModule, ReactiveFormsModule, NgClass],
    styleUrls: ['./org-hierarchy-dialog.scss', '../../org-dialog.scss', '../../../organization-board.component.scss'],
})
export class OrgHierarchyHelpDialogComponent {
    public dialogRef = inject(MatDialogRef) as MatDialogRef<any>;
    public destroy$ = new Subject<void>();
}
